import { PRODUCTS_URL, UPLOAD_URL, } from "../constants";
import { apiSlice } from "./apiSlice";

export const productsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProducts: builder.query({
            query: ({keyword, pageNumber}) => ({
                url: PRODUCTS_URL,
                params: { keyword, pageNumber }
            }),
            providesTags: ['Products'],
            keepUnusedDataFor: 5
        }),
        getAutoCompleteProducts: builder.query({
            query: ({ keyword }) => ({
                url: `${PRODUCTS_URL}/autocomplete`,
                params: { keyword }
            }),
            providesTags: ['Products'],
            keepUnusedDataFor: 5
        }),
        getProductDetails: builder.query({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/${productId}`
            }),
            keepUnusedDataFor: 5
        }),
        addProduct: builder.mutation({
            query: () => ({
                url: PRODUCTS_URL,
                method: "POST"
            }),
            invalidatesTags: ['Product']
        }),
        updateProduct: builder.mutation({
            query: (productData) => ({
                url: `${PRODUCTS_URL}/${productData._id}`,
                method: "PUT",
                body: productData
            }),
            invalidatesTags: ['Products']
        }),
        uploadProductImage: builder.mutation({
            query: (productImageData) => ({
                url: UPLOAD_URL,
                method: "POST",
                body: productImageData
            })
        }),
        deleteProduct: builder.mutation({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/${productId}`,
                method: "DELETE"
            })
        }),
        createProductReview: builder.mutation({
            query: (data) => ({
                url: `${PRODUCTS_URL}/${data.productId}/reviews`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Product']
        }),
        getTopProducts: builder.query({
            query: () => ({
                url:`${PRODUCTS_URL}/top`
            }),
            keepUnusedDataFor: 5
        }),
        getProductReviewsById: builder.query({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/${productId}/reviews`,
            }),
            keepUnusedDataFor: 5
        })
    })
})

export const {
    useGetProductsQuery,
    useGetAutoCompleteProductsQuery,
    useGetProductDetailsQuery,
    useAddProductMutation,
    useUpdateProductMutation,
    useUploadProductImageMutation,
    useDeleteProductMutation,
    useCreateProductReviewMutation,
    useGetTopProductsQuery,
    useGetProductReviewsByIdQuery
} = productsApiSlice;